import {
  AfterViewInit,
  Component,
  computed,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { Filter, FilterTypes, QueryParameters, SortField } from '@app/core/entities/query-parameters.class';
import { ApiService } from '@app/core/services/api/api.service';
import { EventService } from '@app/core/services/event/event.service';
import { UtilService } from '@app/core/services/utils/util.service';
import { WebSocketService } from '@app/core/services/web-socket/web-socket.service';
import {
  TrackTableUpdateData,
  WebsocketSubscriberService,
} from '@app/core/services/websocket-subscriber/websocket.subscriber.service';
import { SidePanelService } from '@app/features/side-panel/side-panel.service';
import { DownloadorderdialogComponent } from '@app/pages/workspace/assign/dialogs/downloadorderdialog/downloadorderdialog.component';
import { HolddialogComponent } from '@app/pages/workspace/assign/dialogs/holddialog/holddialog.component';
import { CurrencyRate } from '@app/services/currency-rates/currency-rate.model';
import { CurrencyRatesService } from '@app/services/currency-rates/currency-rates.service';
import { OrderBatchService } from '@app/services/order-batch/order-batch.service';
import { DeliveryPromise } from '@app/services/order/order.model';
import { OrderService } from '@app/services/order/order.service';
import { PrintService } from '@app/services/print/print.service';
import { ShipmentService } from '@app/services/shipment/shipment.service';
import { Shop } from '@app/services/shops/shop.model';
import { ShopService } from '@app/services/shops/shop.service';
import { TableService } from '@app/services/table/table.service';
import { Order as OrderEntity } from '@app/services/order/order.model';
import { DeleteOrderDialogComponent } from '@app/sharedModule/components/delete-order-dialog/delete-order-dialog.component';
import { NewuiSearchAutocompleteComponent } from '@app/sharedModule/components/newui-search-autocomplete/newui-search-autocomplete.component';
import {
  ColumnName,
  ColumnSettings,
  ColumnTypes,
  GroupAction,
  RowAction,
  TableFilterType,
  tableMessages,
} from '@app/sharedModule/models/table-settings.model';
import {
  CarrierTypeNames,
  ShippingStatus,
  StatusFilters,
  masterCarrierTypeNames,
} from '@pdqdev/pdq-shared/dist/CarrierData';
import { CurrencyUnit, Order, OrderOperation, OrderStatus } from '@pdqdev/pdq-shared/dist/entities';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { getDefaultSortField } from '@utils/shop-utils';
import * as _ from 'lodash';
import moment from 'moment';

import { CookieService } from 'ngx-cookie-service';
import { Subject, Subscription, asyncScheduler } from 'rxjs';
import { finalize, takeUntil, throttleTime } from 'rxjs/operators';
import {
  TABLES,
  addCurrencySignToText,
  createStepFilter,
  formatBillTo,
  formatShippingAddressString,
  formatShippingNameString,
  formattedDate,
  getDeliveryPromise,
  getSignOfCurrency,
  initColumnsOptionsByShop,
  modifyDateRangeValuesByColumn,
} from 'src/utils';
import { isNumber } from 'src/utils/number-utils';
import { PrintDocumentType } from 'src/utils/print-utils';
import { VoidModalComponent } from '../fulfill/components/fulfill-back-to-assign-btn/components/void-modal/void-modal.component';
import { trackColumnsConfig } from './configs/table.config';
import { TrackService } from './services/track.service';
import { FilterOptionsOperators } from '@app/sharedModule/models/filter-options.model';
import { ReturnType } from '@pdqdev/pdq-shared/dist/entities/Return';
import { ExportOptionType } from '@utils/export-utils';
import { assignColorCodingToRows } from '@utils/color-coding.utils';
import { ToastService } from '@app/storybook/services/toast/toast.service';
import { DeliverCursorPaginationService } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.service';
import { DeliverCursorPagination } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.model';
import { TrackCursorPaginationService } from './services/track-cursor-pagination.service';
import { PaginationCursorAction } from '@app/storybook/layouts/components/footer/pagination/pagination.component';

const FreeSearchFieldNameOperatorsMap: { [key: string]: 'IN' | 'LIKE' | 'NOT IN' } = {
  teamNotesUserCollaboration: 'IN',
};

@Component({
  selector: 'app-track',
  templateUrl: './track.component.html',
  styleUrls: ['./track.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  providers: [{ provide: DeliverCursorPaginationService, useClass: TrackCursorPaginationService }],
})
export class TrackComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DatatableComponent) myFilterTableTrack: DatatableComponent;
  @ViewChild(MatSelect) editcolumns: MatSelect;
  @ViewChild(NewuiSearchAutocompleteComponent)
  searchAutocompleteRef: NewuiSearchAutocompleteComponent;
  readonly COLUMN_OPTIONS: ColumnSettings[] = trackColumnsConfig.filter((column: ColumnSettings) => column.canBeHide);
  readonly TABLES = TABLES;
  readonly FilterTypes = FilterTypes;
  countAllStatus: number = 0;
  countDeliveredStatus: number = 0;
  countInTransitStatus: number = 0;
  countPreTransitStatus: number = 0;
  countFlaggedStatus: number = 0;
  returnsCount: number = 0;
  reshipsCount = 0;
  selectedOrders = [];
  selectedReturnToAssignOrdersArray = [];
  rowActions = [
    RowAction.RETURN_ORDER_TO_ASSIGN,
    RowAction.DELETE_ORDER,
    RowAction.PRINT_ORDER,
    RowAction.GET_STATUS,
    RowAction.DOWNLOAD_LABEL,
  ];
  groupActions = [
    GroupAction.EXPORT_ORDERS,
    GroupAction.RETURN_ORDERS,
    GroupAction.PACKING_SLIPS,
    GroupAction.TEAM_NOTE,
    GroupAction.COLOR_CODING,
    GroupAction.BACK_TO_ASSIGN,
  ];
  sidePanelPrintActions = [
    PrintDocumentType.LABELS,
    PrintDocumentType.PACKING_SLIPS,
    PrintDocumentType.BROCHURE,
    PrintDocumentType.COMMERCIAL_INVOICE,
    PrintDocumentType.PACK_AND_SHIP,
    PrintDocumentType.GREETING_CARD,
    PrintDocumentType.CARD_ISLE,
  ];
  tablePrintActions = [PrintDocumentType.PACKING_SLIPS, PrintDocumentType.BROCHURE, PrintDocumentType.CARD_ISLE];
  columns: ColumnSettings[] = [...trackColumnsConfig];
  selectedColumns: string[] = [];
  ordersPerPage = 50;
  allPages = {};
  activePage = 1;
  totalPages = 1;
  totalCountOrders = 0;
  isSyncingGroupOrders = false;
  isCancel = false;
  countDownDate;
  deliveryPromise: DeliveryPromise;
  editcolumnsPannel = false;
  temp = [];
  filter = 'all';
  filterActive = false;
  loading = false;
  rows = [];
  freeSearchValue: any = '';
  freeSearchSelectedField = 'orderNumber';
  selectedCarrier = [];
  shipStatus = [];
  deliveryPromises = [];
  isSyncing = false;
  shopHasPackingSlips: false;
  selectedCarrierOptions: { value: string; text: string }[] = [];
  focusedOrderId: string | null = null;
  backToAssignDays: number;
  shopsCurency: CurrencyUnit = 'ILS';
  currencyRates: { [date: string]: CurrencyRate[] } = {};
  shop: Shop;
  isLoadedInitialData = false;
  screenTitle = 'Track it all';
  isPickingMode: boolean = false;

  deliverCursorPagination = inject(
    DeliverCursorPaginationService,
  ) as DeliverCursorPaginationService<DeliverCursorPagination.TrackTabCounters>;
  useCursorPagination = this.deliverCursorPagination.useCursorPagination;
  cappedAllLabel = computed(() => this.getCappedCounterLabel(FilterTypes.LABEL_ALL));
  cappedPreTransitLabel = computed(() => this.getCappedCounterLabel(FilterTypes.LABEL_PRE_TRANSIT, 'preTransitStatus'));
  cappedInTransitLabel = computed(() => this.getCappedCounterLabel(FilterTypes.LABEL_IN_TRANSIT, 'inTransitStatus'));
  cappedDeliveredLabel = computed(() => this.getCappedCounterLabel(FilterTypes.LABEL_DELIVERED, 'deliveredStatus'));
  cappedFlaggedLabel = computed(() => this.getCappedCounterLabel(FilterTypes.LABEL_FLAGGED, 'flaggedStatus'));
  cappedReturnsLabel = computed(() => this.getCappedCounterLabel(FilterTypes.RETURNS, 'returns'));
  cappedReshipLabel = computed(() => this.getCappedCounterLabel(FilterTypes.RESHIPS, 'reships'));
  private destroyed$: Subject<any> = new Subject();
  private sortFields: SortField[] | 'NONE';
  private tableFilters: Filter[];
  private orderIdSearchParams: string = null;
  private shippingStatusCounters$: Subscription;
  private onShippingStatusCounters$: Subscription;
  private onTrackOrdersFulfillmentChange$: Subscription;
  private queryParamsSubscription$: Subscription;
  private readonly emitTimeoutMS = 10000;

  constructor(
    public dialog: MatDialog,
    public apiService: ApiService,
    public orderService: OrderService,
    public utilService: UtilService,
    private cookieService: CookieService,
    private formBuilder: UntypedFormBuilder,
    private orderBatchService: OrderBatchService,
    private shipmentService: ShipmentService,
    public trackService: TrackService,
    public wsService: WebSocketService,
    private eventService: EventService,
    private wsSubscriber: WebsocketSubscriberService,
    private route: ActivatedRoute,
    private _shopService: ShopService,
    private spService: SidePanelService,
    private tableService: TableService,
    private currencyRatesService: CurrencyRatesService,
    private _printService: PrintService,
    private toastService: ToastService,
  ) {
    this.ordersPerPage = this.orderService.getOrderPerPage();
    this.loadSelectedConfigs();
    this.initShippingStatusCounters();
    this.queryParamsOrderJump();
  }

  async ngOnInit(): Promise<void> {
    this.initShopService();
    this.initSidePanelService();
    this.initTableService();
    this.initFulfillmentStatusChanged();
    this.initTableUpdateWsSubscriber();
  }

  async initCurrencyRatesFromToDates(orders: Order[]) {
    const batchDates: any = orders
      .map((item) => item.orderBatch?.createdDate)
      .filter((item) => item)
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    const minDate: string = batchDates[0];
    const maxDate: string = batchDates[batchDates.length - 1];
    const currencies = orders.map((o) => o.deliveryTransaction?.shippingPriceCurrency).filter(Boolean);
    const uniqueCurrencies = Array.from(new Set(currencies));
    if (!minDate || !maxDate) {
      return;
    }

    const fromDate = minDate.split('T')[0];
    const toDate = maxDate.split('T')[0];
    try {
      const currencyRates: any = await this.currencyRatesService.getCurrencyRatesFromToDates(
        fromDate,
        toDate,
        uniqueCurrencies,
      );
      this.currencyRates = currencyRates.reduce((acc, item) => {
        const date = item.date.split('T')[0];
        if (acc[date]) {
          acc[date] = [...acc[date], item];
        } else {
          acc[date] = [item];
        }
        return acc;
      }, {});
    } catch (e) {
      console.log('Failed to fetch latest currency rates');
    }
  }

  initSidePanelService(): void {
    this.spService.focusedOrderId$.pipe(takeUntil(this.destroyed$)).subscribe(({ focusedId }) => {
      this.focusedOrderId = focusedId ?? null;
    });
  }

  initTableUpdateWsSubscriber() {
    this.wsSubscriber.onTrackOrdersUpdate$
      .pipe(
        throttleTime(this.emitTimeoutMS, asyncScheduler, { leading: true, trailing: true }),
        takeUntil(this.destroyed$),
      )
      .subscribe((data) => {
        this.handleStateUpdate(data);
      });
  }

  private handleCounterUpdate(data: TrackTableUpdateData) {
    if (this.useCursorPagination()) {
      this.handleCursorCounterUpdate(data);
      return;
    }

    if (this.apiService.userLocationIds?.length) {
      const countRelevantToCurrentUser = _.isEqual(
        this.apiService.userLocationIds,
        data.counters?.userLocationCounters?.locationIds,
      );

      this.returnsCount = data.counters?.returns;
      this.reshipsCount = data.counters?.reships;
      if (countRelevantToCurrentUser) {
        const { total, preTransit, inTransit, delivered, flagged } = data.counters.userLocationCounters;
        this.countPreTransitStatus = preTransit;
        this.countInTransitStatus = inTransit;
        this.countDeliveredStatus = delivered;
        this.countFlaggedStatus = flagged;
        this.countAllStatus = total;
      } else {
        this.orderService.getTrackDeliveryStatusCounters().subscribe((counters) => {
          const { inTransitStatus, preTransitStatus, deliveredStatus, all, flaggedStatus, returns, reships } = counters;
          this.countPreTransitStatus = preTransitStatus;
          this.countInTransitStatus = inTransitStatus;
          this.countDeliveredStatus = deliveredStatus;
          this.countFlaggedStatus = flaggedStatus;
          this.countAllStatus = all;
          this.returnsCount = returns;
          this.reshipsCount = reships;
          this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
        });
      }
    } else {
      const { preTransit, inTransit, delivered, flagged, total, returns, reships } = data.counters;
      this.countPreTransitStatus = preTransit;
      this.countInTransitStatus = inTransit;
      this.countDeliveredStatus = delivered;
      this.countFlaggedStatus = flagged;
      this.countAllStatus = total;
      this.returnsCount = returns;
      this.reshipsCount = reships;
    }
  }

  private handleCursorCounterUpdate(data: TrackTableUpdateData) {
    const hasUserLocations = !!this.apiService.userLocationIds?.length;
    const countRelevantToCurrentUser =
      !hasUserLocations || _.isEqual(this.apiService.userLocationIds, data.counters?.userLocationCounters?.locationIds);

    if (!countRelevantToCurrentUser) {
      this.deliverCursorPagination.fetchTabCounters();
      this.refreshCurrentPage();
      return;
    }

    const toCapped = (value: number) => this.deliverCursorPagination.toCappedCount(value, TABLES.TRACK);
    const statusCounters = hasUserLocations ? data.counters.userLocationCounters : data.counters;

    this.deliverCursorPagination.updateTabCounters({
      preTransitStatus: toCapped(statusCounters.preTransit),
      inTransitStatus: toCapped(statusCounters.inTransit),
      deliveredStatus: toCapped(statusCounters.delivered),
      flaggedStatus: toCapped(statusCounters.flagged),
      returns: toCapped(data.counters.returns),
      reships: toCapped(data.counters.reships),
    });
  }

  private handleStateUpdate(data: TrackTableUpdateData) {
    this.handleCounterUpdate(data);
    if (data.ordersToPush) {
      const ordersRelevantToCurrentUser: Order[] = [];
      data.ordersToPush.forEach(({ orders, userLocationIds }) => {
        const areOrdersRelevantToUser =
          !userLocationIds?.length || _.isEqual(this.apiService.userLocationIds, userLocationIds);
        if (areOrdersRelevantToUser) {
          ordersRelevantToCurrentUser.push(...orders);
        }
      });

      this.refreshOrdersState(ordersRelevantToCurrentUser);
    }
  }

  refreshOrdersState(orders: Order[]) {
    const unupdatedRows = [...this.rows].filter((row) => !orders.some((order) => order.id === row.id));
    orders.forEach((order) => {
      this.tableService.deleteOrderCachedMap(order.id);
      const index = this.rows.findIndex((o) => o.id === order.id);

      let rows = [...this.rows];
      if (index !== -1) {
        rows.splice(index, 1, order);
      } else {
        if (order.orderOperation?.includes(OrderOperation.PRIORITIZE)) {
          this.refreshCurrentPage();
          return;
        }
        rows = order.return ? this.handleReturnOrderPush(order, rows) : [...this.rows, order];
      }
      if (this.useCursorPagination()) {
        this.processOrderRows(
          rows,
          unupdatedRows.map((row) => row.id),
        );
      } else {
        this.processOrders(
          { orders: rows, count: rows.length },
          unupdatedRows.map((row) => row.id),
        );
      }
    });
  }
  private handleReturnOrderPush(order: Order, currentRows: Order[]) {
    let rows = [...currentRows];

    const originalOrderIdx = this.rows.findIndex((o) => o.orderNumber === order.orderNumber);
    if (originalOrderIdx !== -1) {
      rows.splice(originalOrderIdx, 0, order);
    } else {
      rows = [...rows, order];
    }

    return rows;
  }
  initTableService(): void {
    this.tableService.onRefreshTableOrders$.pipe(takeUntil(this.destroyed$)).subscribe((orders) => {
      orders.forEach((order) => {
        this.rows.find((o, index) => {
          if (o.id === order.id) {
            this.rows[index] = { ...this.rows[index], ...order };
          }
        });
      });
      this.temp = [...this.rows];
    });

    this.tableService.popoverPressedRowId$.pipe(takeUntil(this.destroyed$)).subscribe((rowId) => {
      this.focusedOrderId = rowId;
    });
  }

  ngAfterViewInit(): void {
    this.editcolumns?.openedChange.subscribe((isOpen) => {
      this.editcolumnsPannel = !!isOpen;
    });
  }

  queryParamsOrderJump(): void {
    this.queryParamsSubscription$ = this.route.queryParams.subscribe((queryParam: any) => {
      this.orderIdSearchParams = queryParam.search;
      if (this.orderIdSearchParams) {
        this.filter = FilterTypes.QUERY_PARAMS;
        this.getPagedOrders(0, this.ordersPerPage);
      }
    });
  }

  initFulfillmentStatusChanged(): void {
    this.onTrackOrdersFulfillmentChange$ = this.wsSubscriber
      .fireTrackOrdersFulfillChanges()
      .pipe(throttleTime(this.emitTimeoutMS, asyncScheduler, { leading: true, trailing: true }))
      .subscribe((data: any) => {
        if (data?.order) {
          this.tableService.refreshSpecificOrder(data.order);
        }
      });
  }

  initShippingStatusCounters(): void {
    if (this.useCursorPagination()) return;
    this.shippingStatusCounters$ = this.orderService.getTrackDeliveryStatusCounters().subscribe((response) => {
      this.countAllStatus =
        response.preTransitStatus + response.deliveredStatus + response.inTransitStatus + response.flaggedStatus;
      this.countPreTransitStatus = response.preTransitStatus;
      this.countDeliveredStatus = response.deliveredStatus;
      this.countInTransitStatus = response.inTransitStatus;
      this.countFlaggedStatus = response.flaggedStatus;
      this.returnsCount = response.returns;
      this.reshipsCount = response.reships;
    });
  }

  loadCarriersOptionsAndCarrierName(row: Order): string {
    const carrierName = row.orderBatch?.selectedCarrier?.name ?? '';
    let formattedCarrierText: string = carrierName;
    let formattedCarrierValue: string = carrierName;

    if (row.deliveryTransaction?.trackingCarrierName) {
      const trackingCarrierName = row.deliveryTransaction.trackingCarrierName;
      formattedCarrierText = `${carrierName} - ${trackingCarrierName ?? ''}`;
      formattedCarrierValue = `deliveryTransaction:${trackingCarrierName}`;
    }

    const existsCarrier = this.selectedCarrierOptions.find((options) => options.text === formattedCarrierText);
    if (!existsCarrier) {
      this.selectedCarrierOptions.push({
        value: formattedCarrierValue,
        text: formattedCarrierText,
      });
    }
    this.selectedCarrierOptions.sort((a, b) => a.text.localeCompare(b.text));
    return formattedCarrierText;
  }

  onSearchToTable(event: { filter: string; searchTerm: string | number; searchField: string }): void {
    this.freeSearchValue = event.searchTerm;
    this.filter = event.filter;
    this.freeSearchSelectedField = event.searchField;
    this.activePage = 1;
    this.getPagedOrders(0, this.ordersPerPage);
  }

  loadSelectedConfigs(): void {
    const data = localStorage.getItem('track-columns');
    this.selectedColumns = data
      ? JSON.parse(data)
      : this.COLUMN_OPTIONS.filter((column: ColumnSettings) => column.canBeHide && column.default).map(
          (column: ColumnSettings) => column.prop,
        );
    this.loadColumnsConfig();
    const packageColumnIndex = this.columns.findIndex((col) => col.name === 'Package name');
    if (packageColumnIndex > 0) {
      this.loadDefaultPackagesOptions(packageColumnIndex);
    }
  }

  loadColumnsConfig(): void {
    localStorage.setItem('track-columns', JSON.stringify(this.selectedColumns));
    this.columns = trackColumnsConfig.filter(
      (column: ColumnSettings) => !column.canBeHide || this.selectedColumns.includes(column.prop),
    );
  }

  toggleColumn(): void {
    this.loadColumnsConfig();
  }

  loadDefaultPackagesOptions(index: number): void {
    this._shopService.shopDefaultBoxes$.pipe(takeUntil(this.destroyed$)).subscribe(({ activeBoxes, inactiveBoxes }) => {
      const boxes = [...activeBoxes];
      const boxOptions = [];
      let customOption;
      boxes?.forEach((box) => {
        const res = {
          value: box.name.toLowerCase(),
          text: box.name,
        };
        if (box.isCustom) {
          customOption = res;
        } else {
          boxOptions.push(res);
        }
      });
      if (customOption) boxOptions.push(customOption);
      this.columns[index].filterSelectOptions = boxOptions;
    });
  }

  reSyncSelectedOrder(): void {
    this.isSyncingGroupOrders = true;
    const ordersID = this.selectedOrders.map((order: Order) => order.id);
    this.orderService
      .syncOrders(ordersID)
      .then(() => {
        this.selectedOrders = [];
        this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
      })
      .finally(() => {
        this.isSyncingGroupOrders = false;
      });
  }

  bulkChangeColorCoding({ orderColors }: { orderColors: Pick<OrderEntity, 'id' | 'colorCoding'>[] }) {
    const previousRows = this.rows;
    this.assignColorsCodingUpdate(orderColors);
    this.orderService.updateOrdersColorCodingV2(orderColors).subscribe({
      error: (error) => {
        this.assignColorsCodingUpdate(previousRows);
        this.toastService.showToast({
          message: `Failed to update color coding`,
          mode: 'danger',
        });
      },
    });
  }

  private assignColorsCodingUpdate(updatedOrders: Pick<OrderEntity, 'id' | 'colorCoding'>[]) {
    const newRows = assignColorCodingToRows(this.rows, updatedOrders, this.shop.colorCoding);

    this.selectedOrders = [...newRows.filter((order) => this.selectedOrders.some((o) => o.id === order.id))];

    const spOrder = this.spService.getActiveOrder();
    if (spOrder?.id) {
      const spColorCoding = updatedOrders.find((order) => order.id === spOrder?.id)?.colorCoding;
      this.spService.setActiveOrder({ ...spOrder, colorCoding: spColorCoding });
    }
    this.temp = [...newRows];
    this.rows = [...newRows];
  }

  exportSelectedOrders({ option }: { option: ExportOptionType }): void {
    const dialogRef = this.dialog.open(DownloadorderdialogComponent, {
      maxWidth: '100vw',
      width: '35vw',
      panelClass: 'exportorders_popup',
      backdropClass: 'global_modal_overlay',
      data: {
        option,
        selectedOrders: this.selectedOrders,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed');
    });
  }

  deleteSelectedOrder(): void {
    const dialogRef = this.dialog.open(DeleteOrderDialogComponent, {
      width: '612px',
      disableClose: true,
      data: {
        rows: this.selectedReturnToAssignOrdersArray,
        table: TABLES.TRACK,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.selectedOrders = [];
      this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
    });
  }

  backToAssignSelectedOrders() {
    const orderIds = [];
    const orderNumbers = [];
    this.selectedReturnToAssignOrdersArray.forEach((order) => {
      orderIds.push(order.id);
      orderNumbers.push(order.orderNumber);
    });
    const dialogRef = this.dialog.open(VoidModalComponent, {
      maxWidth: '100vw',
      width: '35vw',
      panelClass: 'overflow-visible-class',
      backdropClass: 'global_modal_overlay',
      disableClose: true,
      data: {
        orderIds: this.selectedOrders.map((o) => o.id),
        orderNumbers,
        selectedOrdersToAssign: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.selectedOrders = [];
        this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
      }
    });
  }

  backToAssignSingleOrder(row: Order): void {
    // Order fulfilled outside of PDQ, in eCommerce platform
    const fulfilledOutsideTag = 'Fulfilled outside of PDQ';
    if (
      !row.orderBatch &&
      (!row.orderTags?.length || row.orderTags?.find((t) => t.name.includes(fulfilledOutsideTag)))
    ) {
      this.isCancel = false;
      this.backToAssign(row);
      return;
    }

    // Regular orders
    this.orderBatchService.checkBatchCarrierValid(row.orderBatch.id).then((res) => {
      this.isCancel = !!res;
      this.backToAssign(row);
    });
  }

  backToAssign(row): void {
    const dialogRef = this.dialog.open(VoidModalComponent, {
      maxWidth: '100vw',
      width: '35vw',
      panelClass: 'overflow-visible-class',
      backdropClass: 'global_modal_overlay',
      disableClose: true,
      data: {
        orderBatchName: row.batchName,
        orderNumber: row.orderNumber,
        carrierName: row.selectedCarrierName,
        isCancel: this.isCancel,
        orderId: row.id,
        batchId: row.orderBatch?.id,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
        this.selectedOrders = [];
      }
    });
  }

  buildQueryParameters(page, maxsize, sorting: SortField[] | 'NONE' = null): QueryParameters {
    const queryParameters = this.sortFields?.length
      ? this.createQueryParameters(page, this.sortFields)
      : this.createQueryParameters(page);

    if (this.freeSearchValue?.length > 0) {
      queryParameters.filters = [];
      const filter = this.getFreeSearchFilter();
      queryParameters.filters = [filter];
    } else if (this.filter === FilterTypes.MULTIPLE) {
      queryParameters.filters = [
        new Filter(
          this.freeSearchSelectedField,
          FreeSearchFieldNameOperatorsMap[this.freeSearchSelectedField] ?? 'LIKE',
          this.freeSearchValue,
        ),
      ];
    }

    if (this.tableFilters?.length) {
      queryParameters.filters = [...queryParameters.filters, ...this.tableFilters];
    }

    switch (this.filter) {
      case FilterTypes.QUERY_PARAMS: {
        queryParameters.filters.push(new Filter('order.id', 'EQUAL', [this.orderIdSearchParams]));
        break;
      }
      case FilterTypes.ALL_STATUSES: {
        queryParameters.stepFilter = createStepFilter(OrderStatus.STEP_PRINT);
        break;
      }
      case FilterTypes.PRE_TRANSIT: {
        const preTransitStatuses = Array.prototype.concat(StatusFilters.PRE_TRANSIT, ['NULL']);

        queryParameters.filters.push(new Filter('shippingStatus', 'IN', preTransitStatuses));
        break;
      }
      case FilterTypes.IN_TRANSIT: {
        queryParameters.filters.push(new Filter('shippingStatus', 'IN', StatusFilters.IN_TRANSIT));
        break;
      }
      case FilterTypes.DELIVERED: {
        queryParameters.filters.push(new Filter('shippingStatus', 'IN', StatusFilters.DELIVERED));
        break;
      }
      case FilterTypes.FLAGGED: {
        queryParameters.filters.push(new Filter('shippingStatus', 'IN', StatusFilters.FLAGGED));
        break;
      }
      case FilterTypes.RETURNS: {
        queryParameters.filters.push(
          new Filter('order.return.index', FilterOptionsOperators.IN, ['-1', null, ReturnType.DEFAULT]),
        );
        break;
      }
      case FilterTypes.RESHIPS: {
        queryParameters.filters.push(
          new Filter('order.return.index', FilterOptionsOperators.IN, ['-1', null, ReturnType.RESHIP]),
        );
        break;
      }
    }
    return queryParameters;
  }

  getPagedOrders(page, maxsize): void {
    if (this.useCursorPagination()) {
      this.pullOrdersByCursor(page === 0 ? 'first' : 'current');
      return;
    }

    this.loading = true;
    const queryParameters = this.buildQueryParameters(page, maxsize);
    this.initShippingStatusCounters();
    this.orderService
      .getOrdersObs(queryParameters)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(async (data: { orders: any[]; count: number }) => {
        await this.initCurrencyRatesFromToDates(data.orders);
        this.isLoadedInitialData = true;
        this.processOrders(data);
      });
  }

  processOrders(data: { orders: Order[]; count: number }, skipRowIds?: string[]): void {
    this.totalCountOrders = data.count;
    this.totalPages = Math.ceil(data.count / this.ordersPerPage);
    this.utilService.setPages(this.activePage, this.allPages, this.totalPages);
    this.processOrderRows(data.orders, skipRowIds);
  }

  private processOrderRows(orders: Order[], skipRowIds?: string[]): void {
    this.rows = orders;
    const rowsToProcess = skipRowIds ? this.rows.filter((row) => !skipRowIds.includes(row.id)) : this.rows;
    rowsToProcess.forEach((row, i) => {
      row.customerFormated = formatBillTo(row, this.shop.metadata?.isHideEmailInBillTo);
      row.batchName = row.orderBatch?.name ?? '';

      if (row?.deliveryTransaction) {
        row.selectedCarrierName = this.loadCarriersOptionsAndCarrierName(row);

        row.shippingInfo = ''; // row.deliveryTransaction.shippingStatus;

        if (row.deliveryTransaction?.shippingStatusMoreInfo) {
          row.shippingInfo += `${row.deliveryTransaction.shippingStatusMoreInfo}`;
        }

        if (row.deliveryTransaction.translatedShippingStatus) {
          //Only if there is TimeStamp , set shipping status to Delivered + Delivered Date
          const deliveredTimeStamp =
            row?.deliveryTransaction?.externalDeliveredStatusTime || row?.deliveryTransaction?.deliveredStatusTime;
          if (deliveredTimeStamp) {
            const deliveredTime = formattedDate(deliveredTimeStamp, true);
            const deliveredString = 'Delivered';
            //if there is deliveredStatus Time, so the trigger worked, so this is delivered
            row.shippingStatus = deliveredString + '\n' + deliveredTime;
          } else {
            row.shippingStatus = row.deliveryTransaction.translatedShippingStatus;
          }
        }
        const method = row.orderBatch?.selectedCarrier?.method;
        if (method && method.indexOf('polling') > -1) {
          row.showGetStatus = true;
        }
        // Show tracking number instead of shipment id:
        const carrierTypesList = [
          CarrierTypeNames.EASYSHIP,
          CarrierTypeNames.EASYSHIP_TPL,
          CarrierTypeNames.EASYSHIP_MA_INTERNATIONAL,
          CarrierTypeNames.DOORDASH,
          CarrierTypeNames.DOORDASH_MA,
          CarrierTypeNames.DOORDASH_DASHLINK,
        ];
        if (
          carrierTypesList.includes(row.orderBatch?.selectedCarrier?.type?.name) &&
          row.deliveryTransaction?.trackingNumber
        ) {
          row.deliveryTransaction.shippingId = row.deliveryTransaction.trackingNumber;
        }
      }

      if (row?.deliveryTransaction?.shippingPriceAmount && row?.deliveryTransaction?.shippingPriceCurrency) {
        // add currency sign to rate price
        const { shippingPriceAmount, shippingPriceCurrency } = row?.deliveryTransaction;
        const isMACarrier = masterCarrierTypeNames.includes(row.orderBatch?.selectedCarrier?.type?.name);
        const date = row.orderBatch?.createdDate?.split('T')[0];
        const convertedPrice = isMACarrier
          ? this.currencyRatesService.getConvertedPrice(
              shippingPriceAmount,
              shippingPriceCurrency,
              this.shopsCurency,
              this.currencyRates[date],
            )
          : shippingPriceAmount;
        const currency = isMACarrier ? this.shopsCurency : shippingPriceCurrency;
        row.deliveryTransaction.shippingPriceAmount = addCurrencySignToText(convertedPrice, currency);

        // add currency sign to shipment fee
        const currencySign = getSignOfCurrency(currency);
        const deliveryPrice = parseFloat(row.deliveryMethodPrice);
        row.orderShipmentFee = isNumber(deliveryPrice) ? `${currencySign}${deliveryPrice.toFixed?.(2)}` : null;

        // add currency sign to insurance fee
        if (isNumber(row?.deliveryTransaction?.metadata?.insurance?.insuranceFee)) {
          const { insuranceFee } = row.deliveryTransaction.metadata.insurance;
          row.deliveryTransaction.metadata.insurance.insuranceFee = `${currencySign}${insuranceFee.toFixed?.(2)}`;
        }
      }

      row.formattedShippingCityAndProvince = formatShippingAddressString(row);
      row.foramttedShippingName = formatShippingNameString(row);

      row.deliveryPromise = getDeliveryPromise(row);
      row.currentColorTooltipString =
        !row.colorCoding || row.colorCoding.includes('transparent')
          ? ''
          : row.colorCoding
              .map((colorValue) => {
                const current = this.shop.colorCoding?.find((colorData) => colorData.value === colorValue);
                return current?.label || current?.defaultName || '';
              })
              .join(', ');
      // does not suppoerted right now, the tables don't have orderItems data for this calculation
      // row.isPicked = this.isPickingMode && row.orderItems?.every((orderItem) => orderItem.internalStatus == InternalOrderItemStatus.PICKED);
    });

    this.loadCarriersOptions();
    this.temp = this.rows;
  }

  loadCarriersOptions(): void {
    const selectedCarrierColumnIndex = trackColumnsConfig.findIndex((item) => item.prop === 'selectedCarrierName');
    trackColumnsConfig[selectedCarrierColumnIndex].filterSelectOptions = this.selectedCarrierOptions;
  }

  onChangeSelectedOrders(selectedOrders: Order[]): void {
    this.selectedOrders = selectedOrders;

    this.selectedToAssignOrders(selectedOrders);
  }

  selectedToAssignOrders(event): void {
    this.selectedReturnToAssignOrdersArray = [];
    event?.map((order) => {
      if (this.orderCanBeMovedBackToAssign(order)) {
        this.selectedReturnToAssignOrdersArray.push(order);
      }
    });
  }

  orderCanBeMovedBackToAssign(row: Order): boolean {
    return (
      !(
        StatusFilters.IN_TRANSIT.includes(row.deliveryTransaction?.translatedShippingStatus as ShippingStatus) ||
        StatusFilters.DELIVERED.includes(row.deliveryTransaction?.translatedShippingStatus as ShippingStatus)
      ) && moment(row.orderBatch?.createdDate) >= moment().add(-1 * this.backToAssignDays, 'day')
    );
  }

  onChangeTableFilter(columnIndex: number): void {
    this.tableFilters = [];
    this.sortFields = undefined;
    let fieldName;

    this.columns.forEach((column: ColumnSettings) => {
      if (
        !column.filterType ||
        (!column.filterOption && !column.getFilterOption) ||
        (!column.filterValue && !column.filterValueArray?.length && !column.filterValueEnd && !column.filterValueStart)
      ) {
        return;
      }

      if (column.filterType === TableFilterType.TEXT_DATE) {
        fieldName = column.prop;
        const filterValue = column.filterValue ? [column.filterValue] : [null];
        filterValue.push(column.filterValueStart ?? null);

        if (column.filterValueEnd) {
          const endDate = new Date(Date.parse(column.filterValueEnd));
          endDate.setDate(endDate.getDate() + 1);
          filterValue.push(endDate.toISOString());
        }

        this.tableFilters.push(new Filter(fieldName, column.filterOption, filterValue));
      } else {
        fieldName = column?.filterFields || column.prop;
        let filterValue = Array.isArray(column.filterValue) ? column.filterValue : [column.filterValue];

        if (column.filterType === TableFilterType.COLOR) {
          filterValue = column.filterValueArray;
        } else if (column.filterOption === 'DATE RANGE' || column.filterOption === 'DATE RANGE STRICT') {
          filterValue = [];
          if (column.filterValueStart) {
            filterValue.push(column.filterValueStart);
          }
          if (column.filterValueEnd) {
            const endDate = new Date(Date.parse(column.filterValueEnd));
            endDate.setDate(endDate.getDate() + 1);
            modifyDateRangeValuesByColumn(column.prop, { endDate: endDate });
            filterValue.push(endDate.toISOString());
          }
        } else if (column.filterOption === 'LIKE' && !this.shop?.metadata?.applySortingOnFilters) {
          // if we have to add a sort field in the future, consider use id instead of createdDate for better performance
          this.sortFields = 'NONE';
        }

        if (column.filterType !== TableFilterType.TAGS && column.type !== ColumnTypes.PACKAGES) {
          let normalizedValue = (filterValue as string[]).map((x) => (x?.trim ? x.trim() : x));
          if (column.prop === 'orderNumber' && column.filterValue.startsWith('R')) {
            normalizedValue = this.handleReturnOrderNumberFilter(column.filterValue, normalizedValue);
          }
          this.tableFilters.push(
            new Filter(
              fieldName,
              column.filterOption || (column.getFilterOption && column.getFilterOption(column)),
              normalizedValue,
            ),
          );
        }

        if (column.filterType === TableFilterType.TAGS && column.filterValueArray?.length > 0) {
          column.filterValueArray.forEach((filterValue) => {
            this.tableFilters.push(new Filter(filterValue.type, column.filterOption, [filterValue.name]));
          });
        }

        if (column.type === ColumnTypes.PACKAGES) {
          this.tableFilters.push(new Filter(fieldName, column.filterOption, filterValue));
        }

        if (
          column.type === ColumnTypes.SHIPPING_STATUS &&
          column.filterValue?.includes(ShippingStatus.MARK_AS_DELIVERED)
        ) {
          this.tableFilters.push(
            new Filter('selectedCarrierType', 'IN', [CarrierTypeNames.SELF, CarrierTypeNames.SELF_PICKUP]),
          );
        }
      }
    });
    this.filterActive = fieldName ? true : false;
    this.activePage = 1;
    this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
  }

  private handleReturnOrderNumberFilter(filterValue: string, normalizedValue: string[]) {
    let returnIndex = null;
    let orderNumber = null;
    let returnType = null;
    const matchR = filterValue.match(/R(\d*)/);
    const matchDash = filterValue.match(/-(\d*)/);
    const matchRS = filterValue.match(/RS(\d*)/);
    if (matchRS) {
      returnIndex = matchRS[2] || null;
      returnType = ReturnType.RESHIP;
    } else if (matchR) {
      returnIndex = matchR[1] || null;
    }
    if (matchDash) {
      orderNumber = matchDash[1] || null;
    }

    this.tableFilters.push(
      new Filter('order.return.index', FilterOptionsOperators.IN, [`${+returnIndex - 1}`, orderNumber, returnType]),
    );
    return [orderNumber ?? ''];
  }

  getFreeSearchFilter(): Filter {
    return new Filter(
      this.freeSearchSelectedField,
      FreeSearchFieldNameOperatorsMap[this.freeSearchSelectedField] ?? 'LIKE',
      [this.freeSearchValue],
    );
  }

  createQueryParameters(
    page: number,
    sortFields: SortField[] | 'NONE' = [new SortField(getDefaultSortField(this._shopService.shopPlatform), 'DESC')],
  ): QueryParameters {
    const queryParameters = new QueryParameters();
    queryParameters.page = page;
    queryParameters.maxResults = this.ordersPerPage;
    queryParameters.anyAll = 'all';
    queryParameters.filters = [
      new Filter('orderStatus', 'NOT IN', ['hold', 'scheduled', 'stepAssign', 'stepNew']),
      new Filter('deleted', 'IN', ['0']),
    ];
    queryParameters.stepFilter = createStepFilter(OrderStatus.STEP_PRINT);

    if (sortFields && sortFields !== 'NONE') {
      queryParameters.sortFields = [new SortField('orderOperation', 'DESC'), ...sortFields];
    } else if (sortFields !== 'NONE') {
      queryParameters.sortFields = [
        new SortField('orderOperation', 'DESC'),
        new SortField(getDefaultSortField(this._shopService.shopPlatform), 'DESC'),
      ];
    }

    return queryParameters;
  }

  sortColumns(sortOptions): void {
    this.columns = this.columns.map((column: ColumnSettings, i: number) => {
      if (i !== sortOptions.index) {
        return { ...column, sortDirection: null };
      }

      const sortDirection = sortOptions.sortDirection;
      const sortFieldNames: string[] = column.sortFieldName ? column.sortFieldName : [column.prop];

      this.sortFields = sortFieldNames.map((fieldName: string) => new SortField(fieldName, sortDirection));

      return {
        ...column,
        sortDirection,
      };
    });

    this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
  }

  onChangeOrdersPerPage(ordersPerPage: number): void {
    this.ordersPerPage = ordersPerPage;
    this.cookieService.set('orderperpage_cookie', this.ordersPerPage.toString());
    this.activePage = 1;
    this.getPagedOrders(0, this.ordersPerPage);
  }

  onBulkPrint(action): void {
    const ids = this.selectedOrders.map((order) => order.id);
    this._printService.printOrder(action, ids);
    this.selectedOrders = [];
  }

  onDeleteOrder(row: Order): void {
    this.orderBatchService.checkBatchCarrierValid(row.orderBatch?.id).then((res) => {
      if (res) {
        this.isCancel = true;
        this.deleteOrder(row);
      } else {
        this.isCancel = false;
        this.deleteOrder(row);
      }
    });
  }

  deleteOrder(row): void {
    const dialogRef = this.dialog.open(DeleteOrderDialogComponent, {
      width: '612px',
      disableClose: true,
      data: {
        rows: [row],
        table: TABLES.TRACK,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
      this.selectedOrders = [];
    });
  }

  changeColorCoding({ order, colors, selectedOrders }) {
    const orderIds: string[] = selectedOrders ? this.selectedOrders.map((order) => order.id) : [order.id];
    const previousRows = this.rows;
    this.assignColorsCodingUpdate(orderIds.map((id) => ({ id, colorCoding: colors })));
    this.orderService.updateOrdersColorCoding(orderIds, colors).subscribe({
      next: (succededOrders) => {
        if (succededOrders && succededOrders?.length < orderIds.length) {
          const rowsToRevert = previousRows.filter(
            (row) => !succededOrders.some((succededOrder) => succededOrder.id === row.id),
          );
          this.assignColorsCodingUpdate(rowsToRevert);
        }
      },
      error: (error) => {
        this.assignColorsCodingUpdate(previousRows);
        this.toastService.showToast({
          message: `Failed to update color coding`,
          mode: 'danger',
        });
      },
    });
  }

  jumpToPage(page: number): void {
    if (!page) {
      alert('Please enter a valid number');
      return;
    }

    if (page > this.totalPages || page < 1) {
      alert(`Please enter a Page no. less than ${this.totalPages}`);
      return;
    }

    this.activePage = page;
    this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
  }

  paginate(page: number): void {
    this.activePage = page + 1;
    this.utilService.setPages(this.activePage, this.allPages, this.totalPages);
    this.getPagedOrders(page, this.ordersPerPage);
  }

  async onTableActivate({ row }) {
    if (!row.id) {
      return;
    }

    this.spService.setFocusedOrderId(row.id);
  }

  reSyncOrderClick(row, fromSidePanel?: boolean): void {
    this.isSyncing = true;
    row.spinning = true;
    row = { ...row, isSyncing: true, spinning: true };
    if (fromSidePanel) {
      this.spService.setActiveOrder(row);
    }
    this.orderService
      .syncOrder(row.id)
      .catch((e) => {
        this.apiService.errorHandle(e);
      })
      .finally(() => {
        this.isSyncing = false;
        row.spinning = false;
        row = { ...row, isSyncing: false, spinning: false };
        if (fromSidePanel) {
          this.spService.setActiveOrder(row);
        }
      });
  }

  onFilterChange(value): void {
    // reset search input
    this.searchAutocompleteRef.resetFormControl();
    this.filter = value;
    this.activePage = 1;
    this.getPagedOrders(0, this.ordersPerPage);
  }

  updateOrderTrackingStatus(row: Order): void {
    this.shipmentService
      .getOrderStatus(row.id)
      .then((updatedStatus) => {
        row.shippingStatus = updatedStatus;
      })
      .finally(() => {
        this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
      });
  }

  updateOrderToDeliveredStatus(row: Order): void {
    const state: string = 'DELIVERED';
    const fontSize = '18';
    const preText: string = 'You are about to mark order';
    const postText: string = 'as DELIVERED';
    const displayOrderNumbersOnly = true;
    const dialogRef = this.dialog.open(HolddialogComponent, {
      maxWidth: '100vw',
      width: '28vw',
      panelClass: 'hold_popup',
      backdropClass: 'global_modal_overlay',
      disableClose: true,
      data: { rows: [row], state, preText, postText, displayOrderNumbersOnly, fontSize },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
    });
  }

  getShippingStatusTooltip(row: Order): string {
    let tooltip = '';
    const translatedStatus = row?.deliveryTransaction?.translatedShippingStatus;
    let originalStatusString = row?.deliveryTransaction?.shippingStatus || '';
    if (row?.deliveryTransaction?.shippingStatusCode) {
      originalStatusString += ` (${row?.deliveryTransaction?.shippingStatusCode})`;
    }

    if (translatedStatus) {
      tooltip = `${translatedStatus}: ${originalStatusString}`;
    } else tooltip = originalStatusString;

    tooltip += this.trackService.getDriverTooltip(row);

    return tooltip;
  }

  initShopService(): void {
    this._shopService.shop$.pipe(takeUntil(this.destroyed$)).subscribe((shop) => {
      if (!shop) {
        return;
      }

      if (this.useCursorPagination()) {
        this.deliverCursorPagination.fetchTabCounters();
      }

      this.getPagedOrders(0, this.ordersPerPage);

      if (shop.metadata?.disablePrintLabels) {
        this.rowActions = this.rowActions.filter((action) => action != RowAction.PRINT_ORDER);
      }

      this.shop = shop;
      this.adjustColumns(shop);

      const {
        metadata: { supportsMultiCarriers, backToAssignDays, currency, pickingMode },
      } = shop;

      this.shopsCurency = currency;
      this.isPickingMode = pickingMode;

      if (!supportsMultiCarriers) {
        return;
      }

      this.addMultiCarrierColumns();

      if (!backToAssignDays) {
        return;
      }

      this.backToAssignDays = backToAssignDays ?? 3;
    });
  }

  adjustColumns(shop: Shop) {
    this.columns = initColumnsOptionsByShop(
      this.columns,
      shop,
      [ColumnName.INVENTORY_LOCATION],
      this.apiService.userLocationIds,
    );
  }

  // TODO remove? or unify with adjustColumn function
  addMultiCarrierColumns(): void {
    const dynamicColumns: ColumnSettings[] = this.columns.filter((col) => col.type === ColumnTypes.DYNAMIC);

    if (dynamicColumns?.length > 0) {
      dynamicColumns.forEach((selectedCol) => {
        selectedCol.showOnCondition = true;
      });
    }
  }

  chooseEmptyMessage() {
    return this.filterActive || this.filter == 'multiple'
      ? tableMessages.NO_RESULT_MESSAGE
      : tableMessages.EMPTY_MESSAGE;
  }

  ngOnDestroy() {
    this.shippingStatusCounters$?.unsubscribe();
    this.onShippingStatusCounters$?.unsubscribe();
    this.onTrackOrdersFulfillmentChange$?.unsubscribe();
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  getLabelAndCounterString(label: string, counter: number): string {
    return `${label} (${counter})`;
  }

  onCursorPageChange(action: PaginationCursorAction): void {
    this.pullOrdersByCursor(action);
  }

  private getCappedCounterLabel(label: string, counterKey?: keyof DeliverCursorPagination.TrackTabCounters): string {
    const tabCounters = this.deliverCursorPagination.tabCounters();
    if (!tabCounters) return label;

    if (!counterKey) {
      const statuses = ['preTransitStatus', 'inTransitStatus', 'deliveredStatus', 'flaggedStatus'] as const;
      const anyCapped = statuses.some((key) => tabCounters[key].isCapped);
      if (anyCapped) {
        const maxCapped = Math.max(
          ...statuses.filter((key) => tabCounters[key].isCapped).map((key) => tabCounters[key].count),
        );
        return `${label} (${maxCapped}+)`;
      }
      const total = statuses.reduce((sum, key) => sum + tabCounters[key].count, 0);
      return `${label} (${total})`;
    }

    return `${label} (${this.deliverCursorPagination.formatCappedCount(tabCounters[counterKey])})`;
  }

  private refreshCurrentPage(): void {
    if (this.useCursorPagination()) {
      this.pullOrdersByCursor('current');
      return;
    }

    this.getPagedOrders(this.activePage - 1, this.ordersPerPage);
  }

  private pullOrdersByCursor(action: PaginationCursorAction = 'first'): void {
    this.loading = true;
    const query = this.buildQueryParameters(0, this.ordersPerPage);

    this.deliverCursorPagination
      .fetchOrders(action, query, this.ordersPerPage)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(async (orders) => {
        await this.initCurrencyRatesFromToDates(orders);
        this.isLoadedInitialData = true;
        this.processOrderRows(orders);
      });

    if (action === 'first' || action === 'current') {
      this.deliverCursorPagination.fetchTotalCount(query);
    }
  }
}
